module.exports = __webpack_public_path__ + "static/media/git.43d302c6.svg";